import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../common/Button";
import { useState } from "react";
import { cancelTransferRequest } from "../../lib/fetchApi";
import { notificationActions } from "../../store/notifications";
import { transfersActions } from "../../store/transfers";
import Backdrop from "../common/modal/Backdrop";
import Modal from "../common/Modal";
import ModalInnerWrapper from "../common/ModalInnerWrapper";
import PannelBody from "../fragments/PannelBody";
import { getLocationNameFromId } from "../../lib/labels";

export default function CancelTransfer({caseID, transferData, onDashboard}) {
    const dispatch = useDispatch()
    const [loading, isLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    
    const userToken = useSelector(state => state.user.token)

    function openModalHandler() {
        setShowModal(prevState => !prevState)
    }

    function closeModalHandler() {
        setShowModal(false)
    }



    async function cancelTransferHandler() {
        isLoading(true)

        let reqBody = {
            case_practice_id: transferData?.case_practice_id,
            case_practice_transfer_id: transferData?.id
        }

        let cancelTransfer = await cancelTransferRequest(userToken, caseID, reqBody)
        if (cancelTransfer && cancelTransfer.errorMessage) {
            dispatch(notificationActions.setError(cancelTransfer))     
        } else {            
            dispatch(notificationActions.setError({errorMessage: `Transfer Canceled!`, type: 'success'}))    
            
            if (onDashboard) {
                // console.log('refresh dashboard')
            } else {
                dispatch(transfersActions.setRefreshApi())
            }            
            
        }

        isLoading(false)
    }


    return <>
        <Button btnStyle={'btn_small'} click={openModalHandler} >
            Cancel
        </Button>

        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop />,
                document.getElementById("backdrop-root")
            )}
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler}  modalTitle={'Warning'}>
                        <PannelBody>
                            <p>Please cancel all transfer appointments at {getLocationNameFromId(transferData?.from_location_id)} in NG.</p>
                           
                        </PannelBody>
                        <PannelBody>
                            <div className="flex-container">
                                <Button click={cancelTransferHandler} isLoading={loading}>Ok</Button>
                            </div>
                        </PannelBody>
                    </ModalInnerWrapper>    
                </Modal>,
                document.getElementById("overlay-root")
            )}  
            
        </>}
    </>
}